import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class commonService {
    private data = new BehaviorSubject('');
    currentData = this.data.asObservable()

    constructor() { }

    saveUserPreferences(item: any) {
        this.data.next(item);
    }

   
    urlnamevalidation(ngModel, scope) {
        if (ngModel === "DesignURL") {
            if (scope.DesignURL == '' || scope.DesignURL == null) { return true }
            if (scope.DesignURL == scope.ReviewURL || scope.DesignURL == scope.PublishURL || scope.DesignURL == scope.UniversityURL || scope.DesignURL == scope.UniversityCacheURL) {
                return false;
            }
        } else if (ngModel == "ReviewURL") {
            if (scope.ReviewURL == '' || scope.ReviewURL == null) { return true }
            if (scope.ReviewURL == scope.DesignURL || scope.ReviewURL == scope.PublishURL || scope.ReviewURL == scope.UniversityURL || scope.ReviewURL == scope.UniversityCacheURL) {
                return false;
            }
        } else if (ngModel == "PublishURL") {
            if (scope.PublishURL == '' || scope.PublishURL == null) { return true }
            if (scope.PublishURL == scope.DesignURL || scope.PublishURL == scope.ReviewURL || scope.PublishURL == scope.UniversityURL || scope.PublishURL == scope.UniversityCacheURL) {
                return false;
            }
        } else if (ngModel == "UniversityCacheURL") {
            if (scope.UniversityCacheURL == '' || scope.UniversityCacheURL == null) { return true }
            if (scope.UniversityCacheURL == scope.DesignURL || scope.UniversityCacheURL == scope.ReviewURL || scope.UniversityCacheURL == scope.PublishURL || scope.UniversityCacheURL == scope.UniversityURL) {
                return false;
            }
        } else {
            if (scope.UniversityURL == '' || scope.UniversityURL == null) { return true }
            if (scope.UniversityURL == scope.DesignURL || scope.UniversityURL == scope.ReviewURL || scope.UniversityURL == scope.PublishURL || scope.UniversityURL == scope.UniversityCacheURL) {
                return false;
            }
        }
        return true;

    }

    groupBy(list, keyGetter) {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
    }

    isNull(val) {
        if (val != null) {
          return val.toString();
        } else {
          return '';
        }
      }

    isEmpty(val) {
        if (val != '' && val != undefined) {
            return val.toString();
        } else {
            var whitespace = /\s/g.test(val)
            return null;
        }
    }

    trimDeep(value) {
        if (typeof value === "string") {
            return value.trim();
        }

        // Skip Date objects
        if (value instanceof Date) {
            return value;
        }

        if (Array.isArray(value)) {
            return value.map(item => this.trimDeep(item));
        }

        if (value !== null && typeof value === "object") {
            return Object.fromEntries(
                Object.entries(value).map(([key, val]) => [key, this.trimDeep(val)])
            );
        }

        return value;
    }

}